import { ExportActionsService } from './export-actions.service';
import { Row } from '@vendasta/galaxy/table';
import { CRMSelectAllOptions, SelectAllAction } from '@galaxy/crm/static';

export function ExportSelectAllRowAction(
  namespace: string,
  service: ExportActionsService,
  objectType: string,
  label: string,
): SelectAllAction {
  return {
    label: label,
    callback: (rows: Row[], options?: CRMSelectAllOptions) => {
      service.openSelectAllExportDialog(namespace, objectType, options);
    },
  };
}
